import React from 'react'
import { useInfiniteQuery } from 'react-query'
import { useRouter } from 'next/router'

import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { useEbookAction } from '@hooks/ebook/useEbookAction'
import { SelectChapterForEbookProps } from './interface'
import { SelectChapter } from '../SelectChapter'

const limit = 12

export function SelectChapterForEbook({
  bookId,
  ebookId,
}: SelectChapterForEbookProps) {
  const ebookClient = useEbookAction()
  const router = useRouter()
  const { isDarkTheme, isNightTheme, isLightTheme, isSepiaTheme } = useTheme()

  const { fetchNextPage, data, isFetchingNextPage } = useInfiniteQuery(
    ['ebook-freetrial-chapters', bookId, ebookId],
    async ({ pageParam = 1 }) => {
      if (ebookId) {
        const res = await ebookClient.ebookFreeTrialChapterOptions({
          ebookId,
          page: pageParam,
          limitPerPage: limit,
        })
        return res
      }
      const res = await ebookClient.ebookFreeTrialChapterOptions({
        ebookId: bookId,
        page: pageParam,
        limitPerPage: limit,
      })
      return res
    },
    {
      getNextPageParam: (lastPage: any) => {
        if (lastPage.data.length) return lastPage.page + 1

        return undefined
      },
    }
  )

  return (
    <SelectChapter
      onScroll={(e: any) => {
        const scrollHeight = e.target.scrollHeight - 10
        const scrollTop = e.target.scrollTop + e.target.offsetHeight
        if (scrollHeight <= scrollTop && !isFetchingNextPage) {
          fetchNextPage()
        }
      }}
      isEbook
    >
      {data?.pages.map(page =>
        page?.data.map(chapter => {
          return (
            <div
              key={chapter.id}
              className='cursor-pointer'
              onClick={() => {
                if (ebookId) {
                  router.push(
                    `/my-writing/${bookId}/ebook/${ebookId}/chapter/${chapter.id}`
                  )
                } else {
                  router.push(`/ebook/${bookId}/chapter/${chapter.id}`)
                }
              }}
            >
              <SelectChapter.Item
                isDarkTheme={isDarkTheme}
                isNightTheme={isNightTheme}
                isLightTheme={isLightTheme}
                isSepiaTheme={isSepiaTheme}
              >
                {chapter.chapterTitle} {chapter.chapterName}
              </SelectChapter.Item>
            </div>
          )
        })
      )}
    </SelectChapter>
  )
}
